// apps/client/src/pages/leads/edm/components/HtmlAuthoringGuide.tsx
//
// Plan-v3 core Slice E1 (edm_content): what pasted HTML may contain, taken
// from utils/edmHtmlGuide (which mirrors the server sanitiser), plus "Copy
// brief for Claude". Rendered only when isEdmContentEnabled.

import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { BookOpen, ChevronDown, ChevronUp, ClipboardCopy } from 'lucide-react';
import { EDM_UI } from '../../../../utils/edm';
import { EDM_HTML_GUIDE, buildClaudeBrief } from '../../../../utils/edmHtmlGuide';

const HtmlAuthoringGuide: React.FC = () => {
  const [open, setOpen] = useState(false);

  const copyBrief = async () => {
    try {
      if (!navigator.clipboard?.writeText) throw new Error('clipboard unavailable');
      await navigator.clipboard.writeText(buildClaudeBrief());
      toast.success('Brief copied. Paste it into Claude, then add your message.');
    } catch {
      toast.error('Could not copy. Open the guide and copy the rules by hand.');
    }
  };

  return (
    <div className="rounded-lg border border-gray-700 bg-gray-900/40 p-3 text-sm text-gray-300" data-testid="edm-html-guide">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <button
          type="button"
          className="inline-flex items-center gap-2 font-semibold text-gray-100"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <BookOpen className="h-4 w-4 text-blue-400" /> HTML authoring guide
          {open ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
        </button>
        <button type="button" className={EDM_UI.secondaryButton} onClick={() => void copyBrief()}>
          <ClipboardCopy className="h-4 w-4" /> Copy brief for Claude
        </button>
      </div>
      {open && (
        <div className="mt-3 space-y-3">
          {EDM_HTML_GUIDE.map((section) => (
            <div key={section.title}>
              <div className="font-medium text-gray-100">{section.title}</div>
              <ul className="mt-1 list-disc space-y-1 pl-5 text-xs text-gray-300">
                {section.points.map((p) => (
                  <li key={p} className="break-words">
                    {p}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default HtmlAuthoringGuide;
